import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fetchContacts } from '../../store/actions/contacts';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { selectPropertyManagers, selectStrataManagers } from '../../store/selectors/contacts';
import { selectPropertyFormData } from '../../store/selectors/propertyForm';
import { setPropertyFormData, clearPropertyFormData } from '../../store/actions/propertyForm';
import Button from '../Button';
import Col from '../Col';
import Form, { Heading } from '../Form';
import Input from '../Input';
import File from '../File';
import Row from '../Row';
import '../SuiteForm/SuiteAreas.scss';
import './PropertyForm.scss';
import Select from '../Select';
import Loader from '../Loader';
import { selectFormLoader } from '../../store/selectors/FormLoader';
import { selectValidation } from '../../store/selectors/Validation';
import { clearValidation } from '../../store/actions/validation';
import { stopFormLoading } from '../../store/actions/loader';
import * as client from '../../services/client';
import { GOOGLE_API_KEY } from '../../common/constants';
import { selectProperties } from '../../store/selectors/properties';
// import variables from '../../styles/includes/variables.scss';
import moment from 'moment';
import { variables } from '../../Tenants';
import { fetchPropertyStages, fetchPropertyStatuses } from '../../store/actions/formOptions';
import Picker from '../Picker';
import { SortIcon } from '../HomeOwnerDashboard/HomeownerOnboarding/SortIcon';
import { onCheckDocument } from '../../helpers/CommonHelpers';
import Checkbox from '../Checkbox';
import { clearSelectedModulePermission, setSelectedModulePermission } from '../../store/actions/tabSelections';

class PropertyForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      predictions: [],
      location: '',
      errors: {},
      propertyCondition: false,
      sequence: {},
      disableButton:false
    }
  }
  componentDidMount() {
    const { propertyManagers, onFetchContacts, onStopFormLoading, user, onFetchPropertyStages, onFetchPropertyStatuses, clearSelectedModulePermission } = this.props;
    onFetchPropertyStages();
    onFetchPropertyStatuses();
    onStopFormLoading();
    //clearSelectedModulePermission();
    if (propertyManagers.length < 1) {
      onFetchContacts(user.id, user.roles[0].role.name);
    }
  }

  validatePropertyForm() {
    const { onClose, onSaveProperty, propertyFormData, onClearPropertyFormData, validation, clearValidation, properties } = this.props;
    //let postalCodeFormat = /^\d{5}-\d{4}|\d{5}|[A-Z]\d[A-Z] \d[A-Z]\d$/;

    let filteredData;
    if (propertyFormData && propertyFormData.id) {
      filteredData = properties.filter(data => (data.city.toLowerCase().trim() === propertyFormData.city.toLowerCase().trim() && data.name.toLowerCase().trim() === propertyFormData.name.toLowerCase().trim() && propertyFormData.id !== data.id && propertyFormData.propertyManagerId === data.propertyManagerId))
    } else {
      filteredData = properties.filter(data => (data.city.toLowerCase().trim() === propertyFormData.city.toLowerCase().trim() && data.name.toLowerCase().trim() === propertyFormData.name.toLowerCase().trim() && propertyFormData.propertyManagerId === data.propertyManagerId))
    }
   let constructionStages = [];
    if(propertyFormData.selectedStage && propertyFormData.selectedStatus) {
      constructionStages = [...propertyFormData.constructionStages, 
        propertyFormData.selectedStage === 'Custom Stage' ? 
        propertyFormData.selectedDate ? 
        {
           name: propertyFormData.customStageName,
           type:"Custom Stage",
           statusId: propertyFormData.selectedStatus,
           date: new Date(moment(propertyFormData.selectedDate).format('MM/DD/YYYY'))
        } : 
        {
          name: propertyFormData.customStageName,
          type:"Custom Stage",
          statusId: propertyFormData.selectedStatus,
      } : 
      propertyFormData.selectedDate ? 
      {
        id: propertyFormData.selectedStage,
        statusId: propertyFormData.selectedStatus,
        date: new Date(moment(propertyFormData.selectedDate).format('MM/DD/YYYY')),
      } : {
        id: propertyFormData.selectedStage,
        statusId: propertyFormData.selectedStatus
      }
    ]  
    } else {
      constructionStages = propertyFormData.constructionStages
    }
    // let data = {propertyFormData, constructionStages : constructionStages}
    let errors = {}
    if (propertyFormData.name.trim().length === 0) {
      errors.errors = true;
      errors.name = 'Please Enter Property Name !'
    }

    if (propertyFormData.addressLine1.trim().length === 0) {
      errors.errors = true;
      errors.addressLine1 = 'Please Enter Address !'
    }

    if (propertyFormData.city.trim().length === 0) {
      errors.errors = true;
      errors.city = 'Please Enter City !'
    }

    if (propertyFormData.province.trim().length === 0) {
      errors.errors = true;
      errors.province = 'Please Enter Province !'
    }

    if (propertyFormData.postalCode.trim().length === 0) {
      errors.errors = true;
      errors.postalCode = 'Please Enter Postal Code !'
    }
    if (propertyFormData.postalCode.trim().length < 5) {
      errors.errors = true;
      errors.postalCode = 'Please enter a valid postal code with min 5 characters !'
    }
    if (propertyFormData.postalCode.trim().length > 10) {
      errors.errors = true;
      errors.postalCode = 'Please enter a valid postal code with max 10 characters !'
    }
    //if(!propertyFormData.postalCode.match(postalCodeFormat)) {
    //  errors.errors = true;
    //errors.postalCode = 'Postal code should be alphanumeric string  formats are A0A 0A0 , 12345 ,12345-1234 !'
    // }
    let propertyCondition;
    if (filteredData && filteredData.length > 0) {
      propertyCondition = true
      alert('You have already a property with same name and location to that Property Developer.');
    } else {
      propertyCondition = false
    }
    this.setState({ errors })
    if (!errors.errors && !propertyCondition) {
      this.setState({disableButton:true})
      onSaveProperty({...propertyFormData, constructionStages : constructionStages}, this.state.buttonPressed);
      // if(this.state.buttonPressed === 'SaveAndClose'){
      //   onClose();
      // }
      // else{
      //   onClearPropertyFormData()
      // }
    }
  }
  componentDidUpdate() {
    const { validation, onClose, onClearPropertyFormData, clearValidation } = this.props;
    if (validation.status === true) {
      if (validation.message === 'Success' && this.state.buttonPressed === 'SaveAndClose') {
        onClose();
        onClearPropertyFormData();
        clearValidation();
      } else if (validation.message === 'Success' && this.state.buttonPressed === 'SaveAndAdd') {
        onClearPropertyFormData();
        clearValidation();
      }
    }
  }
  onErrorEmpty = (value) => {
    let errors = this.state.errors;
    errors[value] = '';
    this.setState({ errors })
  }
  getLocation = async (value) => {
    this.setState({ location: value })
    client.getLocations(value).then(response => {
      if (response.status === 200) {
        response.json().then(responseJson => {
          let data = JSON.parse(responseJson)
          this.setState({ predictions: data.predictions })
        })
      } else {
        //  alert("Can't find address");
        this.setState({ predictions: [] })
      }
    })
  }
  onClickLocation = async (address) => {
    const { onSetPropertyFormData } = this.props;
    const apiurl = `https://maps.google.com/maps/api/geocode/json?key=${GOOGLE_API_KEY}&address=${address}`;

    try {
      const result = await fetch(apiurl);
      const json = await result.json();
      let latitude = json.results[0].geometry.location.lat;
      let longitude = json.results[0].geometry.location.lng;
      const apiurl1 = `https://maps.google.com/maps/api/geocode/json?key=${GOOGLE_API_KEY}&latlng=${latitude},${longitude}`;

      const getResult = await fetch(apiurl1);
      const addressObj = await getResult.json();
      let addressLine1;
      let city;
      let state;
      let pincode;
      let addressData = addressObj.results[0].address_components;

      if (addressData && addressData.length > 0) {
        addressData.forEach(data => {
          if (data.types.indexOf('street_number') != -1) {
            addressLine1 = data.long_name
          }
          if (data.types.indexOf('route') != -1) {
            addressLine1 = addressLine1 ? addressLine1 + ', ' + data.long_name : data.long_name
          }
          if (data.types.indexOf('neighborhood') != -1) {
            addressLine1 = addressLine1 ? addressLine1 + ', ' + data.long_name : data.long_name
          }
          if (data.types.indexOf('sublocality_level_2') != -1) {
            addressLine1 = addressLine1 ? addressLine1 + ', ' + data.long_name : data.long_name
          }
          if (data.types.indexOf('sublocality_level_1') != -1) {
            addressLine1 = addressLine1 ? addressLine1 + ', ' + data.long_name : data.long_name
          }
          // if(!addressLine1) {
          //   if (data.types.indexOf('point_of_interest') != -1) {
          //     addressLine1 = data.long_name
          //   }
          // }
          if (data.types.indexOf('locality') != -1) {
            city = data.long_name
          }
          if (data.types.indexOf('administrative_area_level_1') != -1) {
            state = data.long_name
          }
          if (data.types.indexOf('postal_code') != -1) {
            pincode = data.long_name
          }
        });
        onSetPropertyFormData({ addressLine1: addressLine1, city: city, province: state, postalCode: pincode })
        this.setState({ predictions: [], location: '' })
      } else {
        // alert("Can't find address");
      }
    } catch (err) {
      // alert("Can't find address");
    }
  }
  onAddNewConstructionStatus = (type) => { 
    const { propertyFormData, onSetPropertyFormData } = this.props;
    
    if(type === false) {
      onSetPropertyFormData({constructionStages : propertyFormData && propertyFormData.id ? [...propertyFormData.constructionStages, {new : true}] : [{new : true}]})
      onSetPropertyFormData({ selectedStage : '', selectedStatus: '', selectedDate: '', customStageName: '', isCustomStageEnabled: false})
    } else {
    if (propertyFormData && propertyFormData.constructionStages && propertyFormData.constructionStages.length > 0) {

      let constructionStages = propertyFormData.constructionStages
      constructionStages = propertyFormData.constructionStages.filter(cs => !cs.new)     
       
      onSetPropertyFormData({
        constructionStages : [
          ...constructionStages,
          propertyFormData.selectedStage === 'Custom Stage' ? 
          propertyFormData.selectedDate ? 
          {
             name: propertyFormData.customStageName,
             type:"Custom Stage",
             statusId: propertyFormData.selectedStatus,
             date: new Date(moment(propertyFormData.selectedDate).format('MM/DD/YYYY'))
          } : 
          {
            name: propertyFormData.customStageName,
            type:"Custom Stage",
            statusId: propertyFormData.selectedStatus,
          }
          :
          propertyFormData.selectedDate ? 
        {
          id: propertyFormData.selectedStage,
          statusId: propertyFormData.selectedStatus,
          date: new Date(moment(propertyFormData.selectedDate).format('MM/DD/YYYY')),
        } : {
          id: propertyFormData.selectedStage,
          statusId: propertyFormData.selectedStatus
        }
        ,{
          new : true
        }
      ]})
    } else {
      onSetPropertyFormData({
        constructionStages: [
          propertyFormData.selectedStage === 'Custom Stage' ? 

            propertyFormData.selectedDate ? 
            {
               name: propertyFormData.customStageName,
               type:"Custom Stage",
               statusId: propertyFormData.selectedStatus,
               date: new Date(moment(propertyFormData.selectedDate).format('MM/DD/YYYY'))
            } : 
            {
              name: propertyFormData.customStageName,
              type:"Custom Stage",
              statusId: propertyFormData.selectedStatus,
         } :
         propertyFormData.selectedDate ? 
          {
        id: propertyFormData.selectedStage,
        statusId: propertyFormData.selectedStatus,
        date: new Date(moment(propertyFormData.selectedDate).format('MM/DD/YYYY'))
      } : {
          id: propertyFormData.selectedStage,
          statusId: propertyFormData.selectedStatus
      }
    ]})
    }

    onSetPropertyFormData({ selectedStage : '', selectedStatus: '', selectedDate: '', customStageName: '', isCustomStageEnabled: false})
    // onSetPropertyFormData({ constructionStages: [...constructionStages, {new : true}]})
  }
  }
  onhandleStatusUpdate = (value, index, type) => {
    const { propertyFormData, onSetPropertyFormData } = this.props;
   let data =  propertyFormData.constructionStages.map((ps, index1) => {
      if(index === index1) {
        if(ps.type === 'Custom Stage' && ps.id && ps.id !== value) {
          if(type === 'name') {
            return { ...ps, 'name': value }
          } else {
            return { 'name': '', 'type' : null, statusId: ps.statusId, id: value }
          }
        }
        else if(value === 'Custom Stage') {
          return { 'name': '', 'type' : 'Custom Stage', statusId: ps.statusId }
        } else {
        if(type === 'name') {
          return { ...ps, 'name': value, 'type' : 'Custom Stage' }
        } else {
         return { ...ps, [type] : type === 'date' ? new Date(moment(value).format('MM/DD/YYYY')) : value}
        }
      }
      } else {
        return ps
      }
    })
    onSetPropertyFormData({ constructionStages : data })
  }
  onhandleStatusDelete = (index, obj) => {
    const { propertyFormData, onSetPropertyFormData } = this.props;
    let data = propertyFormData.constructionStages.filter(ps => ps !== obj)
    onSetPropertyFormData({
      constructionStages: data
    })  
  }
  onChangeRank = (data, index) => {
      const { propertyFormData, onSetPropertyFormData } = this.props;
      let sortArray = propertyFormData.constructionStages.map((ps) => {
        if(ps === this.state.sequence) {
          return data
        } else if(ps === data) {
          return this.state.sequence
        } else {
          return ps
        }
      })
      onSetPropertyFormData({
        constructionStages: sortArray
      })
  }
  onSetModules=(selectedModule)=>{
    const {tabSelections, setSelectedModulePermission, onSetPropertyFormData}=this.props
    let selectedModulePermissions = tabSelections.selectedModulePermissions;
    let index = selectedModulePermissions.findIndex((object) => object.Id === selectedModule);
    
    if (index === -1) {
      setSelectedModulePermission([...tabSelections.selectedModulePermissions,{Id:selectedModule}])
      onSetPropertyFormData({ modulePermissions:[...tabSelections.selectedModulePermissions,{Id:selectedModule}] })
    } else {
      selectedModulePermissions = selectedModulePermissions.filter(
        (data) => data.Id !== selectedModule
      );
      setSelectedModulePermission(selectedModulePermissions);
      onSetPropertyFormData({ modulePermissions: selectedModulePermissions })
    }
  }
  render() {
    const { onClose, onSetPropertyFormData, propertyFormData, user, loader, strataManagers, propertyStages, propertyStatuses, tabList, tabSelections } = this.props;
    let propertyManagers = this.props.propertyManagers;
    let isModulePErmissionsSelected =(propertyFormData.hasOwnProperty("modulePermissions") ? propertyFormData.modulePermissions.length > 0?true:false:false );
    let selectedModulePermissions = tabSelections.selectedModulePermissions;
    if (user.roles[0].role.name === 'Property Developer') {
      propertyManagers = this.props.propertyManagers.filter(item => item.id === user.id);
    }

    let filterData = propertyFormData && propertyFormData.constructionStages && propertyFormData.constructionStages.length > 0 ? propertyFormData.constructionStages.filter(cs => cs.new) : []
    return (
      <Form
        headline={(propertyFormData.id ? 'Edit' : 'Add a') + ' Property'}
        onClose={onClose}
        // onSubmit={() => this.validatePropertyForm()}
        actions={(
          <>
            {loader ? <Loader center={true} /> : null}
            {!propertyFormData.id ? <Button
              color="semantic"
              size="small"
              label="Save and Add Another"
              onClick={() => this.setState({
                buttonPressed: 'SaveAndAdd'
              }, () => this.validatePropertyForm())}
              disabled={!propertyFormData.name || !propertyFormData.addressLine1 || !propertyFormData.city || !propertyFormData.province || !propertyFormData.postalCode || !propertyFormData.propertyManagerId || !isModulePErmissionsSelected || this.state.disableButton}
            /> : <div />}
            <Button
              color="teal"
              size="small"
              label="Save Property"
              onClick={() => this.setState({
                buttonPressed: 'SaveAndClose'
              }, () => this.validatePropertyForm())}
              disabled={!propertyFormData.name || !propertyFormData.addressLine1 || !propertyFormData.city || !propertyFormData.province || !propertyFormData.postalCode || !isModulePErmissionsSelected || this.state.disableButton || (propertyFormData.propertyManager && propertyFormData.propertyManager.id ? !propertyFormData.propertyManager.id : (!propertyFormData.propertyManagerId || propertyFormData.propertyManagerId === '00000000-0000-0000-0000-000000000000'))}
            />
          </>
        )}
        
        component={(
          <>
            <Row mdCenter>
              <Col
                xs="12"
                md="6"
              >
                <Heading>Property Details</Heading>
                <Input
                  value={propertyFormData.name}
                  onChange={e => onSetPropertyFormData({ name: e.target.value })}
                  label="Property Name"
                  required
                  placeholder="eg., Example Property"
                  block
                  errors={this.state.errors.name}

                />
                <Select
                  value={
                    propertyFormData.propertyManagerId && propertyFormData.propertyManagerId !== '00000000-0000-0000-0000-000000000000' ?
                      propertyFormData.propertyManagerId
                      : propertyFormData.propertyManager && propertyFormData.propertyManager.id ?
                        propertyFormData.propertyManager.id : ''}
                  onChange={e => onSetPropertyFormData({ propertyManagerId: e.target.value, propertyManager: {} })}
                  options={propertyManagers.map(propertyManager => ({ value: propertyManager.id, label: `${propertyManager.firstname} ${propertyManager.lastname}` }))}
                  label={variables.propertyDeveloper}
                  placeholder={"(Select " + variables.propertyDeveloper + ")"}
                  block
                />

                <Select
                  value={
                    propertyFormData.strataManagerId ?
                      propertyFormData.strataManagerId
                      : propertyFormData.strataManager && propertyFormData.strataManager.id ?
                        propertyFormData.strataManager.id : ''}
                  onChange={e => onSetPropertyFormData({ strataManagerId: e.target.value })}
                  options={strataManagers.map(strataManager => ({ value: strataManager.id, label: `${strataManager.firstname} ${strataManager.lastname}` }))}
                  label="Strata Manager"
                  placeholder="(Select Strata Manager)"
                  required={false}
                  block
                />
                <Input
                  value={this.state.location}
                  onChange={e => this.getLocation(e.target.value)}
                  label="Search Location"
                  block
                  placeholder="Search Location"
                />
                {this.state.predictions.map((item, i) => {
                  return (
                    <div className='location_search'
                      onClick={() => this.onClickLocation(item.description)}>
                      {item.description}
                    </div>
                  )
                })}
                <Input
                  value={propertyFormData.addressLine1}
                  onChange={e => onSetPropertyFormData({ addressLine1: e.target.value })}
                  label="Address"
                  required
                  placeholder="eg., 123 Example Street"
                  block
                  errors={this.state.errors.addressLine1}
                />
                <Row>
                  <Col
                    xs="12"
                    md="4"
                  >
                    <Input
                      value={propertyFormData.city}
                      onChange={e => onSetPropertyFormData({ city: e.target.value })}
                      label="City"
                      required
                      placeholder="eg., Vancouver"
                      block
                      errors={this.state.errors.city}
                    />
                  </Col>
                  <Col
                    xs="12"
                    md="4"
                  >
                    <Input
                      value={propertyFormData.province}
                      onChange={e => onSetPropertyFormData({ province: e.target.value })}
                      label="Province"
                      required
                      placeholder="eg., BC"
                      block
                      errors={this.state.errors.province}
                    />
                  </Col>
                  <Col
                    xs="12"
                    md="4"
                  >
                    <Input
                      value={propertyFormData.postalCode}
                      onChange={e => {
                        this.onErrorEmpty('postalCode')
                        return (
                          onSetPropertyFormData({ postalCode: e.target.value })
                        )
                      }
                      }
                      label="Postal Code"
                      required
                      placeholder="eg., A0A 0A0"
                      block
                      errors={this.state.errors.postalCode}
                    />
                  </Col>

                </Row>

                <label class="input__label">Permissions<span style={{color:'red'}}>*</span></label>
                <br/>
                <Row>
                  {
                    tabList.map((item)=>
                    {
                      let result = selectedModulePermissions.length>0?(selectedModulePermissions.find(
                        (object) => object.Id === item.id)):null
                      let resultId = result===undefined || result===null ?
                          null : result && result.Id ? result.Id:null;
                        return(
                        <Col
                          xs="12"
                          sm="12"
                          md="6"
                          lg="6"
                        >
                        <Checkbox
                          checked={resultId === item.id?true:false}
                          name={resultId === item.id ? resultId : null}
                          value={resultId === item.id ? resultId : ''}
                          label={item.name}
                          onChange={(e) => {
                            this.onSetModules(item.id)
                          }}
                        />
                        </Col>
                      )
                    }
                    )
                  }
                </Row>

                <File
                  label="Image"
                  onSelect={(file) => { onCheckDocument(file) && onSetPropertyFormData({ selectedImage: file }) }}
                  files={propertyFormData.selectedImage ? propertyFormData.selectedImage : []}
                  image={propertyFormData.image}
                  errors={''}
                  type='image'
                />
                <label class="input__label">Construction Status</label>
                {propertyFormData && propertyFormData.constructionStages && propertyFormData.constructionStages.length > 0 ? propertyFormData.constructionStages.map((ps, i) => {
                  return (
                    <div className='propertyForm' 
                    draggable={true}
                    onDragStart={() => this.setState({ sequence : ps})}
                    onDrop={() => this.onChangeRank(ps, i)}
                    >
                      <div className='construction'>
                        <div className='construction1'>
                          <div className='construction2'>
                          <div className='imageContainer'>
                            <div style={{paddingLeft: 25}}>
                                <SortIcon />
                                </div>
                                </div>
                                <div className='stageContainer'>
                                  <label>Select Stage<span style={{color:'red'}}>*</span></label>
                                <select className='stages'
                                  defaultValue=""
                                  value={ps && ps.new ? propertyFormData.selectedStage ? propertyFormData.selectedStage : '' : (ps.id && ps.type === 'Custom Stage') ? ps.type : ps.id ? ps.id : ps.type}
                                  onChange={(e) => ps && ps.new ? e.target.value === 'Custom Stage' ? onSetPropertyFormData({ selectedStage: e.target.value, isCustomStageEnabled: true }) : onSetPropertyFormData({ selectedStage: e.target.value, isCustomStageEnabled: false }) : this.onhandleStatusUpdate(e.target.value, i, 'id')}
                                >                                  
                                  <option value="" disabled>Select stage</option>
                                  {[...propertyStages, {id: 'Custom Stage', name: 'Custom Stage'}].map((stage, i) => {
                                    return (
                                      <option value={stage.id}>{stage.name}</option>
                                    )
                                  })}
                                </select>
                                </div>
                                {propertyFormData && propertyFormData.selectedStage === 'Custom Stage' && !ps.id || ps.type === 'Custom Stage' || (ps.id && ps.type === 'Custom Stage') ?
                                <div className='stageContainer'>
                                <input placeholder="Custom stage" type='text' className='custominput'
                                  value={ps && ps.new ? propertyFormData.customStageName ? propertyFormData.customStageName : '' : ps.name}
                                  onChange={(e) => ps && ps.new ? onSetPropertyFormData({ customStageName: e.target.value }) : this.onhandleStatusUpdate(e.target.value, i, 'name')}
                                />
                                </div> : null}
                                <div className='stageContainer' style={{paddingRight: '0px'}}>
                                <label>Status<span style={{color:'red'}}>*</span></label>
                                <select className='stages'
                                  defaultValue=""
                                  value={ps && ps.new ? propertyFormData.selectedStatus ? propertyFormData.selectedStatus : '' : ps.statusId}
                                  // onChange={(e) => onSetPropertyFormData({ selectedStatus: e.target.value })}
                                  onChange={(e) => ps && ps.new ? onSetPropertyFormData({ selectedStatus: e.target.value }) : this.onhandleStatusUpdate(e.target.value, i, 'statusId')}

                                >
                                  <option value="" disabled>Status</option>
                                  {propertyStatuses.map((status, i) => {
                                    return (
                                      <option value={status.id}>{status.name}</option>
                                    )
                                  })}
                                </select>
                                </div>
                                <div className='crossContainer' style={{cursor: 'pointer'}}>
                                <img src="/assets/cross.png" style={{ marginTop: '7px' , width: '18px'}} onClick={() => window.confirm(`Are you sure you want to delete construction stage?`) && this.onhandleStatusDelete(i, ps)}/>
                                </div>
                          </div>
                        </div>
                      </div>
                      <div className='dateContainer'>
                            <div class="dateContainer3">
                       <Picker
                    placeholderText="Date"
                    required={false}
                    showPopperArrow={false}
                    selected={
                     ps && ps.new ? (propertyFormData.selectedDate ? propertyFormData.selectedDate : null) : ps.date && ps.date === '0001-01-01T00:00:00+00:00' ? null : ps.date ? new Date(ps.date) : null}
                    onChange={(date) => ps && ps.new ? onSetPropertyFormData({ selectedDate: date }) : this.onhandleStatusUpdate(date, i, 'date')}
                  />
                            </div>
                      </div>
                    </div>

                  )
                }) : null}

                <div style={{ marginTop: 10 }}>
                  <Button
                    color="teal"
                    size="small"
                    label="+ Add New Construction Status"
                    onClick={() => this.onAddNewConstructionStatus(!propertyFormData.selectedStatus || !propertyFormData.selectedStage ? false : true)}
                  //  disabled={propertyFormData && propertyFormData.id ? false : propertyFormData.constructionStages && propertyFormData.constructionStages.length > 0 ? !propertyFormData.selectedStatus || !propertyFormData.selectedStage : false}
                   disabled={filterData && filterData.length > 0 ? !propertyFormData.selectedStatus || (propertyFormData && propertyFormData.selectedStage && propertyFormData.selectedStage === 'Custom Stage' && !propertyFormData.customStageName ? true : !propertyFormData.selectedStage) : false}
                 />
                </div>
              </Col>
            </Row>
          </>
        )}
      />
    );
  }
}

const mapStateToProps = state => ({
  propertyFormData: selectPropertyFormData(state),
  propertyManagers: selectPropertyManagers(state),
  strataManagers: selectStrataManagers(state),
  user: selectAuthenticatedUser(state),
  validation: selectValidation(state),
  loader: selectFormLoader(state),
  properties: selectProperties(state),
  propertyStages: state.formOptions.propertyStages,
  propertyStatuses: state.formOptions.propertyStatuses,
  tabSelections:state.tabSelections,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onFetchContacts: fetchContacts,
  onSetPropertyFormData: setPropertyFormData,
  onClearPropertyFormData: clearPropertyFormData,
  clearValidation: clearValidation,
  onStopFormLoading: stopFormLoading,
  onFetchPropertyStages: fetchPropertyStages,
  onFetchPropertyStatuses: fetchPropertyStatuses,
  setSelectedModulePermission:setSelectedModulePermission,
  clearSelectedModulePermission,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PropertyForm);
